export default "__VITE_ASSET__DruaB38f__"